import { createSlice } from "@reduxjs/toolkit";
import { getSubAdminList } from "src/redux/services/sub-admin.service";

const initialState = {
  loading: false,
  subAdminList: [],
};
const subAdminSlice = createSlice({
  name: "subAdmin",
  initialState,
  reducers: {
    reset() {
      return {
        ...initialState,
      };
    },
  },
  extraReducers: {
    ///getSubAdminList

    [getSubAdminList.pending]: (state) => {
      state.loading = true;
    },
    [getSubAdminList.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.subAdminList = payload.data.data;
      state.message = payload.message;
    },
    [getSubAdminList.rejected]: (state, { payload }) => {
      state.loading = false;
      state.message = payload;
    },
  },
});
export default subAdminSlice.reducer;
